import './index.scss';

import { Component, ErrorInfo, ReactNode } from 'react';

import config from '../../config';
import storage from '../../utils/storage';

export type ErrorBoundaryProps = {
    children: ReactNode
};

type ErrorBoundaryState = {
    hasError: boolean
};

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {

    state = {
        hasError: false
    };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        if (config.production)
            return;

        console.log(window.location, window.history.state, error, errorInfo);

        if (config.test)
            console.log(window.location.href, JSON.stringify(window.history.state), JSON.stringify(error), JSON.stringify(errorInfo));
    }

    render() {
        if (!this.state.hasError)
            return this.props.children;

        let message: ReactNode = null;

        switch (storage.get('brax.user.language')) {
            case 'en':
                message = (<>
                    <h1>Unexpected error!</h1>

                    <p>The application could not recover from this error, please reload the page to retry.</p>
                </>);
                break;

            // case 'es':
            //     message = (<></>);
            //     break;

            default:
                message = (<>
                    <h1>Houve um erro inesperado!</h1>

                    <p>A aplicação não pôde se recuperar desse erro, recarregue a página para reiniciá-la.</p>
                </>);
                break;
        }

        return (
            <div className="error-boundary">{ message }</div>
        );
    }
}
